export default __webpack_public_path__ + "static/media/1975.3c115f7a.png";